import { isSsr } from '@99designs/browser';
import { AppConfigData } from '@99designs/layout';

// This sets the public path for webpack
if (isSsr()) {
    // eslint-disable-next-line no-undef
    __webpack_public_path__ = `${process.env.SPA_ASSET_ORIGIN}${process.env.SPA_ASSET_PATH || ''}/`;
} else {
    const appConfigNode = document.getElementById('app-config-init-data');
    const appConfigData: AppConfigData = appConfigNode?.textContent
        ? JSON.parse(appConfigNode.textContent)
        : {};
    /* eslint-disable-next-line no-undef */
    __webpack_public_path__ = `${appConfigData.webpackPublicPath}/`;
}

export {};
